import Chip from '@mui/material/Chip'
import { useTranslation } from 'react-i18next'

import { PortfolioState } from '@/features/bidding/types/bid'

interface PortfolioStateChipProps {
  state: PortfolioState
}

function getChipColor(state: PortfolioState): 'success' | 'warning' | 'primary' {
  switch (state) {
    case PortfolioState.LIVE:
      return 'success'
    case PortfolioState.LIVE_WITHOUT_BIDDING:
      return 'warning'
    case PortfolioState.NOT_LIVE:
    case PortfolioState.INACTIVE:
    default:
      return 'primary'
  }
}

/**
 * Displays the portfolio state as a chip with appropriate color coding.
 */
function PortfolioStateChip({ state }: Readonly<PortfolioStateChipProps>) {
  const { t } = useTranslation()

  const stateKey = `portfolio_hierarchy.portfolioStates.${state}` as const

  return (
    <Chip
      color={getChipColor(state)}
      data-testid="portfolio-state-chip"
      label={t(stateKey as any)}
      size="small"
      variant="outlined"
    />
  )
}

export default PortfolioStateChip
